

















































import { defineComponent, onMounted, ref } from "@vue/composition-api";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/BaseInput";

export default defineComponent({
  name: "PostTippingView",
  components: { BaseAvatar, BaseConfirm, BaseInput, BaseIcon, BaseButton },
  props: {
    value: { type: String, required: true },
    processing: { type: Boolean, default: false },
    success: { type: Boolean, default: false },
    currencySymbol: { type: String, required: true },
  },
  setup(props, { emit }) {
    const show = ref(false);

    const hideModal = () => {
      emit("close");
      show.value = false;
    };

    onMounted(() => {
      show.value = true;
    });

    return {
      show,
      hideModal,
    };
  },
});
